/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import { baseChallengeClipBodySchema } from '../challenge-clip-body-schema';

export const updateChallengeClipBodySchema = baseChallengeClipBodySchema.partial();

export type IUpdateChallengeClipBody = z.infer<typeof updateChallengeClipBodySchema>;

export interface IUpdateChallengeClipRequest {
  challengeId: number;
  clipId: number;
  body: IUpdateChallengeClipBody;
}
